export const mediaKeys = {
  all: [{ module: 'media' }] as const,
  filesLists: () => [{ ...mediaKeys.all[0], scope: 'filesList' }] as const,
  filesList: (jobId: string) => [{ ...mediaKeys.filesLists()[0], jobId }] as const,
  analysisStatuses: () => [{ ...mediaKeys.all[0], scope: 'analysisStatus' }] as const,
  analysisStatus: (mediaId: string) => [{ ...mediaKeys.analysisStatuses()[0], mediaId }] as const,
};
